import { type FetchCumulativeLimitsParams } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchCumulativeLimits } from '../api';

/**
 * @params FetchCumulativeLimitsParams
 * @returns Cumulative limits
 */
export const useCumulativeLimitsQuery = (params?: FetchCumulativeLimitsParams) => {
	return useQuery({ queryFn: () => fetchCumulativeLimits({ ...params }), queryKey: ['cumulativeLimits', params] });
};
